import React, { useCallback, useContext, useEffect, useMemo, useRef } from 'react';
import { Row } from "tea-component";
import { getLocale, shallowEqual, useSelector } from 'umi';
import CountryRegionRowItem from '@/pages/dashboard/components/CountryRegionRowItem';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';
import { useCommonRankShowData } from './_hooks';
import { formatExeclCommon, formatExeclNormalPercent, formatExeclNum, formatExeclSharePercent, handleDownload } from '../../utils/utils';
import { useSelectorMap } from '../../utils/customHook';

import './index.scss';

export interface CountriesContextsProps {
  data: any;
  config: any;
  state: any;
}

const CommonRankListCo = (props: CountriesContextsProps) => {
  const { data: comData, config, state } = props;

  const { regionDataType = 'country' } = state || {};
  const { componentMetrics, comConfig, isUseTableDownload, metric, isShowMapByCountry, initChartIndex = 0 } = config || {};
  const { getFilterItemText } = useSelectorMap();
  const contextObj = useContext(FilterContext);
  const { filterVal } = contextObj || {};
  const {  rangeTime } = filterVal || {};
  const gameCode  = useSelector((state: any) => state.dashboard?.currentGame?.game_code, shallowEqual);
  const regionDataTypeRef = useRef(regionDataType);
  // 解决切换tab的时候数据历史数据未清楚，会一闪而过的问题
  const regionDataTypeUpdate = regionDataTypeRef?.current !== regionDataType;
	
  useEffect(() => {
    regionDataTypeRef.current = regionDataType;
  }, [regionDataType]);

  const { data, loading, error } = useMemo(()=>{
    const { data, loading, error } = comData?.data;
    return { data, loading, error };
  },[comData]);

  const {renderComConfig, initChartIndexVal} = useMemo(()=>{
    // 没有country的map地图的时候直接返回原配置
    if(!isShowMapByCountry){
      return  {
        renderComConfig: comConfig,
        initChartIndexVal: initChartIndex
      };
    }
    // 有country的map地图的时候，只有country的时候才有地图
    const renderComConfig = {
      ...(comConfig || {}),
      isHaveMap: regionDataType === 'country'
    };
    return {
      renderComConfig,
      initChartIndexVal: initChartIndex
    };
  },[comConfig,isShowMapByCountry,regionDataType, initChartIndex]);

  const { tableColumnTitle, prefix, chartTooltipsName, titleContent, tableColumns, isSingle } = useCommonRankShowData({ accumated: regionDataType, filterVal, gameCode, config });
  const renderData = data?.[metric];

  const downloadFunc = useCallback(() => {
    const hasOthersValue = renderData?.tableData?.find((item: { name: string; }) => item?.name === 'Others')?.value !== '';
    const downloadDatas: any = [];
    renderData?.tableData?.forEach((item: any) => {
      if (!hasOthersValue && item?.full_name === 'Others') return;
      const values = item?.value;
      downloadDatas.push({
        name: getFilterItemText(regionDataType, item?.full_name, item?.full_name, true),
        [metric]: componentMetrics?.type === 'percent' ? formatExeclNormalPercent(values) : componentMetrics?.type === 'int' ? formatExeclNum(values) : formatExeclCommon(values),
        share_of_all: formatExeclSharePercent(item?.share_of_all),
      });
    });
    const tableConfig: {
      option: any;
      downloadData: any;
    } = {
      option: tableColumns,
      downloadData: downloadDatas
    };
    handleDownload(tableConfig, titleContent?.name, false);
  }, [renderData, getLocale(), metric, tableColumns, regionDataType]);

  return (
    <Row gap={24} className="dbd-breakdown-box">
      <CountryRegionRowItem
        prefix={prefix}
        titleName={tableColumnTitle}
        titleContent={titleContent}
        regionDataType={regionDataType === 'system' ? 'os' : regionDataType}
        comConfig={renderComConfig}
        timeRange={rangeTime}
        initActiveIndex={initChartIndexVal}
        loading={regionDataTypeUpdate || loading}
        isSingle={isSingle}
        isError={error}
        downloadFunc={isUseTableDownload ? downloadFunc : null}
        data={renderData}
        isUserQuota={componentMetrics?.type === 'int'}
        timeType={filterVal?.timeType}
        chartTooltipsConfig={{
          tooltipsName: chartTooltipsName,
          tooltipsType: componentMetrics?.type,
          tooltipsDecimal: componentMetrics?.decimal,
          tooltipsPercentDecimals: componentMetrics?.percentDecimals,
        }}
        tableColumns={tableColumns}
        gameCode={gameCode}
        showConfig={componentMetrics?.showConfig}
        morePie
      />

    </Row>
  );
};

export default CommonRankListCo;